import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
 
import App from './App';  
import Sachin from './Sachin';
import BlenderPortfolio from './BlenderPortfolio';
import Donep from './Donep';
import Contact from './Contact';
import Education from './Education';
import Curser from './Curser';
import Team from './Team';
import Loader from './Loader';
import Test from './Test';
import Header from './Header';
// import About from './About';

import Teammember from './Teammember';
  
import reportWebVitals from './reportWebVitals';

function MainApp() {
  const [isLoading, setIsLoading] = useState(true);
  const [hideLoader, setHideLoader] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setHideLoader(true); // Start fade out
      setTimeout(() => setIsLoading(false), 500); // Remove loader
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <React.StrictMode>
      {isLoading ? (
        <Loader fadeOut={hideLoader} />
      ) : (
        <>
          <Header />
          <Sachin />
          <BlenderPortfolio />
          <Education />
          <Donep />
          <Team />
 < Teammember/>
           <br></br>

          <Contact />
          {/* <About/> */}
          <Curser />
          <Test />
        </>
      )}
    </React.StrictMode>
  );
}

const root = ReactDOM.createRoot(document.getElementById('Sachin'));
root.render(<MainApp />);

reportWebVitals();
